<template>
  <CardModule title="Eleven Cashless">
    <v-row>
      <v-col cols="12">
        <BaseTextField
          label="URL Eleven Cashless"
          placeholder="Insira a URL do Eleven Cashless"
          v-model="$produtos_gerenciar.cadastro.cashless.url_cashless_prod"
        />
      </v-col>
    </v-row>
  </CardModule>
</template>

<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";

export default {
  name: "AccessRules",
  components: {
    CardModule,
    BaseTextField,
  },
  data: () => ({}),
  computed: {},
};
</script>

<style scoped></style>
